module.exports = __webpack_public_path__ + "static/media/15-1.1a60e4a4.webp";